import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getAirlineList(params) {
  return request({
    url: URL.partner.airline,
    method: 'get',
    params
  })
}

export function saveAirline(data) {
  return request({
    url: URL.partner.airline,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delAirline(uuid) {
  return request({
    url: URL.partner.airline + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

export function getMAWBInfo(airLineUuid) {
  return request({
    url: URL.partner.getMAWBInfo + '?airlineUuid=' + encodeURIComponent(airLineUuid),
    method: 'get'
  })
}

export function getAirlineData(params) {
  return request({
    url: URL.partner.getAirlineData,
    method: 'get',
    params
  })
}
